import cx from "classnames";
import { FC, SVGProps } from "react";

import { Icon } from "atoms/icon/Icon";
import CheckSmall from "atoms/icon/icons/ic_check_xsmall_ol.svg";

interface CircleProgressTrackerProps {
  current: number;
  max: number;
  labels?: string[];
  checkIcon?: FC<SVGProps<SVGSVGElement>>;
  className?: string;
  "data-testid"?: string;
}

export const CircleProgressTracker = ({
  current,
  max,
  labels,
  checkIcon = CheckSmall,
  className,
  "data-testid": dataTestId,
}: CircleProgressTrackerProps) => {
  const completedSteps = Math.min(Math.max(0, current), max);

  return (
    <div className={cx("relative mx-auto", className)} data-testid={dataTestId}>
      <div
        className="absolute top-1.5 h-2"
        style={{ left: "9px", right: "9px" }}
      >
        <div className="h-[5px] rounded-full border border-brand-color" />
        <div
          className="absolute left-0 top-0 h-[5px] rounded-full bg-brand-color transition-all duration-300"
          style={{ width: `${(completedSteps / max) * 100}%` }}
        />
      </div>

      <div className="relative flex justify-between">
        {Array.from({ length: max }, (_, index) => {
          const isCompleted = index + 1 <= completedSteps;
          return (
            <div key={index} className="flex flex-col items-center">
              <div
                className={cx(
                  "relative z-0 flex items-center justify-center rounded-full border transition-all duration-300",
                  isCompleted
                    ? "border-1 border-white bg-brand-color"
                    : "border-brand-color bg-white"
                )}
                style={{ height: "18px", width: "18px" }}
              >
                {completedSteps === 0 ? (
                  <span className="text-center text-xs font-semibold text-brand-color">
                    {index + 1}
                  </span>
                ) : (
                  isCompleted && (
                    <Icon
                      svg={checkIcon}
                      size="x3small"
                      color="white"
                      className="flex items-center justify-center"
                    />
                  )
                )}
              </div>

              {labels?.[index] && (
                <div className="mt-2 text-center text-xs font-semibold text-brand-color">
                  {labels[index]}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
